<!--  -->
<template>
  <div>
    <div class="logo">
        <img src="../assets/AILAND.png" alt="">
    </div>
    <div class="circle">
        <div class="circle1">
          <img src="../assets/circle_01.png" alt="">
        </div>
        <div class="circle2">
          <img src="../assets/circle_02.png" alt="">
        </div>
        <div class="circle3">
          <img src="../assets/circle_03.png" alt="">
        </div>
        <div class="circle4">
          <img src="../assets/circle_04.png" alt="">
        </div>
    </div>
    <div class="dl"> 
        <div class="picture" id="container"></div>
        <div  class="login_content">
            <div class="biaoti">
                <!-- <img src="../assets/biaoti_03.png" alt=""> -->
                <a target="_blank" style="color:#f198a7 ;font-size: 26px; font-weight: bold;">请使用360极速浏览器登录本系统</a>
            </div>
            <div  v-show="dl_phone"  class="dl_01">
                <div id="dl_code" class="code">
                   <img src="../assets/code.png" @click="showsaoma" title="扫码登录更便捷" alt="">
                </div>

                <el-form class="form1" ref="ruleFormLogin" :model="ruleFormLogin" :rules="RulesLogin">
                  <el-form-item prop="userno">
                    <div class="box">
                      <el-input type="text" clearable v-model="ruleFormLogin.userno"  name="searchtext"  placeholder="请输入手机号">
                        <template slot="prepend"><img src="../assets/zhanghao.png" alt=""></template>
                      </el-input>
                    </div>
                  </el-form-item>
                  <el-form-item prop="userpwd">
                    <div class="box2">
                      <el-input type="password" clearable v-model="ruleFormLogin.userpwd" name="mima"  placeholder="请输入密码">
                        <template slot="prepend"><img src="../assets/mima.png" alt=""></template>
                      </el-input>
                    </div>
                  </el-form-item>
                  <!-- 将忘记密码移到这里，放在密码输入框下方 -->
                  <div id="forget" @click="wjshow" class="forget">
                    <span>忘记密码？</span>
                  </div>
                  <el-button type="button" :loading="loginloading" @click="password_login('ruleFormLogin')" class="login_button">登 录</el-button>
                </el-form>
            </div>
             <div v-show="dl_code2" class="dl_02">
                   <div id="dl_code02" class="code_02">
                       <img src="../assets/mima_01.png" @click="hidesaoma" title="密码登录" alt="">
                   </div>
                   <div class="scan_code">
                     <span id="show_code"></span>
                       <!-- <img src="../assets/scan_code.png" alt=""> -->
                   </div>
                   <!-- <div class="tips">
                    <p style="text-align: center;">请使用企业微信扫描二维码登录<br>“用户集成平台”</p>
                   </div> -->
                   <div class="atips">
                       <a href="https://work.weixin.qq.com/#indexDownload" target="_blank" style="color:#f198a7 ;">点击下载企业微信安装包</a>
                   </div>  
                   <div class="atips">
                       <a href="https://down.360safe.com/cse/360csex_setup.exe" target="_blank" style="color:#f198a7 ;font-size: 18px; font-weight: bold;">点击下载360极速浏览器安装包</a>
                   </div> 
            </div>
            <div  v-if="wj" class="dl_03" >
                <div id="dl_code1" @click="hidewj" class="code_02">
                  <img src="../assets/mima_01.png" @click="hidesaoma" title="密码登录" alt="">
                </div>
                <el-form class="form1" ref="ruleFormLogin" :model="ruleFormLogin" :rules="RulesLogin">
                  <el-form-item prop="phone">
                    <div class="box">
                      <el-input
                        v-model="ruleFormLogin.phone"
                        :maxlength="11"
                        @blur="checkPNumber_info"
                        type="nmuber"
                        placeholder="请输入手机号"
                        clearable
                      >
                        <template slot="prepend"><img src="../assets/zhanghao.png" alt=""></template>
                      </el-input>
                    </div>
                  </el-form-item>
                  <el-form-item >
                    <div class="box2">
                      <Captcha 
                        ref="captcha" 
                        @verified="handleCaptchaVerified" 
                      />
                      <span v-if="errors.captcha" class="error">{{ errors.captcha }}</span>
                    </div>
                  </el-form-item>
                  <!-- 添加温馨提示 -->
                  <div v-if="ts" class="wj_text">
                    温馨提示：<br>
                        需要先在职员管理里面添加完成，才可修改密码
                  </div>
                  <el-button type="button" :loading="loginloading" @click="submit" class="login_button">确认手机号</el-button>
                </el-form>
                <!-- <div class="wj_text2">
                    <input type="text" name="" placeholder="请输入密码">
                </div> -->
                <!-- 验证码组件 -->
                
            </div>
            <div  v-if="gm" class="dl_02" >
              <div id="dl_code1" @click="gmhidewj" class="code_02">
                <img src="../assets/mima_01.png" @click="hidesaoma" title="密码登录" alt="">
              </div>
              <el-form class="form1" ref="ruleFormLogin" :model="ruleFormLogin" :rules="RulesLogin">
                <el-form-item prop="phone">
                  <div class="box">
                    <el-input
                      v-model="ruleFormLogin.phone"
                      :maxlength="11"
                      @blur="checkPNumber_info"
                      type="nmuber"
                      disabled
                    >
                      <template slot="prepend"><img src="../assets/zhanghao.png" alt=""></template>
                    </el-input>
                  </div>
                </el-form-item>
                <!-- 新密码（8位以上，数字+字母） -->
                <div class="password-tips">
                  密码要求：8-20位，必须包含字母和数字，建议使用特殊字符增加安全性
                </div>
                <el-form-item prop="newPassword">
                  <div class="box2">
                    <el-input 
                      type="password" 
                      v-model="ruleFormLogin.newPassword" 
                      placeholder="请输入新密码（8位以上，含数字和字母）"
                      show-password
                    >
                      <template slot="prepend">新密码</template>
                    </el-input>
                  </div>
                </el-form-item>

                <!-- 确认密码 -->
                <el-form-item prop="confirmPassword">
                  <div class="box2">
                    <el-input 
                      type="password" 
                      v-model="ruleFormLogin.confirmPassword" 
                      placeholder="请再次输入密码"
                      show-password
                    >
                      <template slot="prepend">确认密码</template>
                    </el-input>
                  </div>
                </el-form-item>
                <!-- 验证码输入 -->
                <div class="password-tips">
                  温馨提示：短信验证码来自 成都大诚珠宝 的短信
                </div>
                <el-form-item prop="smsCode">
                  <div class="box2">
                    <el-input
                      v-model="ruleFormLogin.smsCode"
                      placeholder="请输入短信验证码"
                      :maxlength="6"
                      clearable
                    >
                      <template slot="append">
                        <el-button 
                          @click="getSmsCode" 
                          :disabled="countdown > 0"
                        >
                          {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
                        </el-button>
                      </template>
                    </el-input>
                  </div>
                </el-form-item>
                <el-button type="button" :loading="loginloading" @click="gmsubmit" class="login_button">确认修改</el-button>
              </el-form>
              <!-- <div class="wj_text2">
                  <input type="text" name="" placeholder="请输入密码">
              </div> -->
              <!-- 验证码组件 -->
              
          </div>
            <div class=" three_sides">
                <!-- <ul>
                    <li><a href="">财务软件</a></li>
                    <li><a href="">财务软件</a></li>
                    <li><a href="">财务软件</a></li>
                </ul> -->
            </div>   
        </div>
    </div>
    <div class="versnumber">
        <span>Copyright©2007-2023  &nbsp; 爱恋珠宝信息中心  &nbsp;  www.ailend.com   &nbsp;   ©蜀ICP备06023048号</span>
    </div>
  </div>
</template>

<script>
import Captcha from '@/components/Captcha.vue'; // 引入组件
export default {
  name: "login",
  data() {
        // 密码强度验证（8位以上，包含数字和字母）
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 8) {
        callback(new Error('密码长度至少8位'));
      } else if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
        callback(new Error('密码必须包含字母和数字'));
      } else {
        callback();
      }
    };
    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.ruleFormLogin.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      errors: {
        username: '',
        password: '',
        captcha: '',
      },
      isCaptchaValid: false,
      isactive: "",
      loginUrl2020: API.loginUrl2020,
      datatime: "",
      boxtype: false,
      show: false,
      show2: false,
      seciphone: "", //登录成功返回给首页的加密手机号
      login_forgetpaw: false,
      /* 控制忘记密码块是否显示 */
      login_normal: false,
      /* 控制默认登录块是否显示 */
      login_scandnormal: true,
      /* 控制默认登录块是否显示 */
      user_right_hint: false,
      /* 没有权限提示框 */
      login_right_hint: false,
      /* 没有登录提示框 */
      resetPawForm: {
        pwd_userno: "",
        /* 重置密码页的手机号 */
        pwd_userpwd: "",
        /* 重置密码页的密码 */
      },
      rulseReset: {
        pwd_userno: {
          required: true,
          message: "请输入用户名",
          trigger: "change",
        },
        pwd_userpwd: {
          required: true,
          message: "请输入新密码",
          trigger: "change",
        },
      },

      pwd_code: "",
      /* 重置密码页的验证码 */
      yanzhengname: "获取验证码",
      code_isdisable: false,
      middle_result: "", //中转页传过来的用户有没有登录信息。
      iphone_code: "", //中转页传过来的加密手机号
      exaple0: "",
      ruleFormLogin: {
        //密码登录字段
        userno: "",
        /* 密码登录的手机号/用户名 */
        userpwd: "",
        /* 密码登录的密码 */
        phone: "",
        smsCode: "",
        newPassword: "",
        confirmPassword: "",
      },
      RulesLogin: {
        userno: { required: true, message: "请输入用户名", trigger: "blur" },
        userpwd: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码必须是6位数字', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loginloading: false, //登陆loading

      countdown: 0,
      loginloading: false,
      dl_code2: false,
      dl_phone: true,
      wj: false,
      gm: false,
      ts: false,
    };
  },

  components: { Captcha },
  computed: {},
  created: function () {
    localStorage.hfkeyid = "";
    localStorage.hfkeypath = "";
    let gloo = this.btnlogin();
    // console.log(gloo);
    if (gloo != "Chrome") {
      this.boxtype = true;
    }
    var savertime = new Date(
      $.ajax({ async: false, cache: false }).getResponseHeader("Date")
    )
      .toLocaleDateString()
      .replace(/\//g, "-");
    this.datatime = savertime;
  },
  mounted: function () {
    const container = document.getElementById("container");
    console.log('1-----',container.style.backgroundPositionX)
    console.log('2------',container.style.backgroundPositionY)
    window.onmousemove = function(e){
      let x = e.clientX / 10;
      // let y = e.clientY / 20;  
      container.style.backgroundPositionX = (-440 + x) + "px";
      // container.style.backgroundPositionY = (-70 + y) + "px";
    }
    this.getCurrentDate();
    let _this = this;
    this.show_codes();
    this.getMiddleCode();
    setTimeout(()=>{					//加密狗注释代码
				console.log("加密狗");			//加密狗注释代码
				this.delay();					//加密狗注释代码
		},1000);							//加密狗注释代码
  },
  
  watch: {
    middle_result: function (val, oldval) {
      // console.log("val--", val);
      if (val == "65302") {
        this.login_right_hint = true;
      }
    },
    //       iphone_code:function(val,oldval){
    //           console.log("val--",val);
    // 　　　　　　if(val){
    //             this.login_right_hint=true;
    //           }
    // 　　　　 },
    
  },
  /* watch */

  methods: {
    doginfo:function(){
				// console.log("执行加密狗方法")
				Button1_onclick();
			},
		delay:function(){
				let _this = this;
				if(localStorage.hfkeyid){
					console.log('localStorage.hfkeyid',localStorage.hfkeyid)
					// _this.loadingform();
				}else{
					// console.log("获取加密狗失败，重新获取")
					setTimeout(function(){
						_this.doginfo();
						_this.delay();
					},1000);
				}
		},
        // 获取短信验证码（同上）
    getSmsCode() {
      if (!this.ruleFormLogin.phone) {
        this.$message.error('手机号不能为空');
        return;
      }
      let postData = this.qs.stringify({
                iphone: this.ruleFormLogin.phone,
      });
      this
        .axios({
          url: API.API_TOKEN + "PublicLogin/VerUserCode",
          method: "POST",
          data: postData,
        })
        .then((res) => {
          if  (res.data.error_code == 0) {
            this.$message.success('验证码已发送');
            this.startCountdown();
          } else {
            this.$message({
              message: res.data.error_message,
              type: "error",
            });
          }
          
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },

    // 倒计时逻辑（同上）
    startCountdown() {
      this.countdown = 400;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) clearInterval(timer);
      }, 1000);
    },
    validatePasswordss() {
      const { smsCode ,newPassword, confirmPassword } = this.ruleFormLogin;
      
      // 检查两次密码是否一致
      if (newPassword !== confirmPassword) {
        return { valid: false, message: "两次输入的密码不一致" };
      }
      // 使用正则表达式检查是否为6位数字
      if (!/^\d{6}$/.test(smsCode)) {
        return { valid: false, message: "验证码必须是6位数字" };
      }
      // 检查密码长度
      if (newPassword.length <= 8) {
        return { valid: false, message: "密码长度必须大于8位" };
      }
      
      // 检查是否包含字母和数字
      const hasLetter = /[a-zA-Z]/.test(newPassword);
      const hasNumber = /[0-9]/.test(newPassword);
      
      if (!hasLetter || !hasNumber) {
        return { valid: false, message: "密码必须包含字母和数字" };
      }
      
      return { valid: true, message: "密码有效" };
    },
    // 提交表单
    gmsubmit() {
            // 调用密码验证
      const result = this.validatePasswordss();
      
      if (!result.valid) {
        // 显示错误提示
        this.$message.error(result.message);
        return;
      }
      let postData = this.qs.stringify({
                iphone: this.ruleFormLogin.phone,
                newpwd: this.ruleFormLogin.confirmPassword,
                code: this.ruleFormLogin.smsCode,
      });
      this
        .axios({
          url: API.API_TOKEN + "PublicLogin/UpdateUserPwdnew",
          method: "POST",
          data: postData,
        })
        .then((res) => {
          if  (res.data.error_code == 0) {
          this.$message.success('密码修改成功,还回登录界面');
          this.dl_phone = true; 
          this.gm = false;
          } else if (res.data.error_code == 1004) {
            this.$message.success('20分钟内，请用已发送验证码');
            this.startCountdown();
          } else {
            this.$message({
              message: res.data.error_message,
              type: "error",
            });
          }
          
        })
        .catch(error => {
          this.$message.error(error.message);
        });

    },
    checkPNumber_info() {
      //弹层验证手机号码
      // if (!this.xzForm.inputIphone_xz) {
      //   this.$message.error("号码不能为空!");
      // }
      let reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (!reg.test(this.ruleFormLogin.phone)) {
        this.$message.error("请输入正确的手机号!");
      }
    },
    // 验证码结果回调
    handleCaptchaVerified(isValid) {
      this.isCaptchaValid = isValid;
      this.errors.captcha = isValid ? '' : '验证码未通过';
    },
    async submit() {
      // 直接比对验证码
      const captcha = this.$refs.captcha;
      if (captcha.userInput.toLowerCase() !== captcha.captchaText.toLowerCase()) {
        this.errors.captcha = '验证码错误';
        captcha.refreshCaptcha();
        return;
      }
      else
      {
        this.errors.captcha = '';
      }
      // 2. 获取短信验证码
      if (!this.ruleFormLogin.phone) {
        this.$message.error('手机号不能为空');
        return;
      }
      let postData = this.qs.stringify({
                iphone: this.ruleFormLogin.phone,
      });
      this
        .axios({
          url: API.API_TOKEN + "PublicLogin/VerUserCode",
          method: "POST",
          data: postData,
        })
        .then((res) => {
          if  (res.data.error_code == 0) {
            this.wj = false; 
            this.gm = true;
            this.$message.success('验证码已发送');
            this.startCountdown();
          } else if (res.data.error_code == 1004) {
            this.wj = false; 
            this.gm = true;
            this.$message.success('20分钟内，请用已发送验证码');
            this.startCountdown();
          } else {
            this.ts = true;
            this.$message({
              message: res.data.error_message,
              type: "error",
            });
          }
          
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    //获取当前时间
    getCurrentDate() {
      var timeStr = "-";
      var curDate = new Date();
      var curYear = curDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var curMonth = curDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      var curDay = curDate.getDate(); //获取当前日(1-31)
      var curWeekDay = curDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      var curHour = curDate.getHours(); //获取当前小时数(0-23)
      var curMinute = curDate.getMinutes(); // 获取当前分钟数(0-59)
      var curSec = curDate.getSeconds(); //获取当前秒数(0-59)
      var Current =
        curYear +
        timeStr +
        curMonth +
        timeStr +
        curDay +
        " " +
        curHour +
        ":" +
        curMinute +
        ":" +
        curSec;
      //获取服务器时间
      var benditime = new Date(curDate)
        .toLocaleDateString()
        .replace(/\//g, "-");
      // var savertime = new Date($.ajax({async: false}).getResponseHeader("Date")).toLocaleDateString().replace(/\//g, '-');
      // this.datatime = savertime;
      console.log(benditime + "==" + this.datatime);
      if (benditime != this.datatime) {
        this.$alert(
          "当前电脑时间与网络时间不一致，请调整本地电脑时间为当天时间",
          "警告！",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {
              return false;
            },
          }
        );
      }
    },
    //扫码登陆
    show_codes() {
      window.WwLogin({
        id: "show_code",
        appid: "ww28bec14dd8939eae",
        agentid: API.SAO_AGENTID,
        redirect_uri: API.SAO_URL,
        state: "",
        href: API.SAO_CSS,
      });
    },
    btnlogin: function () {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var s;
      (s = ua.match(/msie ([\d.]+)/))
        ? (Sys.ie = s[1])
        : (s = ua.match(/firefox\/([\d.]+)/))
        ? (Sys.firefox = s[1])
        : (s = ua.match(/chrome\/([\d.]+)/))
        ? (Sys.chrome = s[1])
        : (s = ua.match(/opera.([\d.]+)/))
        ? (Sys.opera = s[1])
        : (s = ua.match(/version\/([\d.]+).*safari/))
        ? (Sys.safari = s[1])
        : 0;
      if (Sys.ie) return "IE";
      if (Sys.firefox) return "Firefox";
      if (Sys.chrome) return "Chrome";
      if (Sys.opera) return "Opera";
      if (Sys.safari) return "Safari";

      // if(navigator.userAgent.indexOf("MSIE")>0) {                                 // MSIE内核
      // 		return "MSIE";
      // 	}
      // if(navigator.userAgent.indexOf("Firefox")>0){                                 // Firefox内核
      // 		return "Firefox";
      // 	}
      // if(navigator.userAgent.indexOf("Opera")>0){                                  // Opera内核
      // 		return "Opera";
      // 	}
      // if(navigator.userAgent.indexOf("Safari")>0) {                                  // Safari内核
      // 		return "Safari";
      // 	}
      // if(navigator.userAgent.indexOf("Camino")>0){                                  // Camino内核
      // 		return "Camino";
      // 	}
      // if(navigator.userAgent.indexOf("Gecko")>0){                                    // Gecko内核
      // 		return "Gecko";
      // 	}
    },
    downloadbox: function () {
      //下载浏览器跳转地址
      window.location.href =
        "https://dl.softmgr.qq.com/original/Browser/72.0.3626.119_chrome_installer-1.exe";
    },
    turn_scand() {
      /* 点击跳转到扫码登录页 */
      var that = this;
      that.login_normal = false;
      that.login_forgetpaw = false;
      that.login_scandnormal = true;
    },
    turn_forgerpaw() {
      /* 点击跳转到忘记密码页 */
      var that = this;
      that.login_forgetpaw = true;
      that.login_normal = false;
      that.login_scandnormal = false;
      that.$refs["ruleFormLogin"].resetFields();
    },
    turn_paw() {
      /* 点击跳转到密码登录页 */
      var that = this;
      that.login_forgetpaw = false;
      that.login_normal = true;
      that.login_scandnormal = false;
      that.$refs["resetPawForm"].resetFields();
      that.pwd_code = "";
    },
    validatePasswords() {
      const { userpwd } = this.ruleFormLogin;
      // 检查密码长度
      if (userpwd.length <= 8) {
        return { valid: false, message: "密码长度必须大于8位" };
      }
      
      // 检查是否包含字母和数字
      const hasLetter = /[a-zA-Z]/.test(userpwd);
      const hasNumber = /[0-9]/.test(userpwd);
      
      if (!hasLetter || !hasNumber) {
        return { valid: false, message: "密码必须包含字母和数字" };
      }
      
      return { valid: true, message: "密码有效" };
    },
    /* 密码登录 */
    password_login(formName) {

      const result = this.validatePasswords();
      if(!localStorage.hfkeyid || localStorage.hfkeyid === ""){					//加密狗注释代码
        return { valid: false, message: "密码必须包含字母和数字" };
      }
      if (!result.valid) {
        // 显示错误提示
        this.$message.error(result.message);
        return;
      }
      let _this = this;
      this.loginloading = true;                                                           //加密狗注释代码
      let postData = this.qs.stringify({
        version: API.VERSION_NUM,
        username: _this.ruleFormLogin.userno,
        password: _this.ruleFormLogin.userpwd,
        logincode: "pos",
        type: 0, //0不要加密狗 1要加密狗  ----加密狗修改项----
      });
      _this
        .axios({
          url: API.API_TOKEN + "PublicLogin/UserPwd",
          method: "POST",
          data: postData,
        })
        .then((res) => {
          _this.loginloading = false;
          console.log("密码登录数据成功", res);
          if (res.data.error_code == "1002") {
            _this.$message({
              message: "密码和用户名不能为空",
              type: "warning",
            });
          } else if (res.data.error_code == "65302") {
            _this.$message({
              message: "该用户不存在",
              type: "warning",
            });
          } else if (res.data.error_code == 0) {
            // _this.seciphone = res.data.iphone;
            localStorage.tnk = res.data.data[0].iphone;
            localStorage.fzhitype = res.data.data[0].ktokd; //获取是否是直营店
            localStorage.agenceid = res.data.data[0].agenceid; //控制下柜下拉值---内容
            //    this.$router.push({path: '/',query:{middle_result:this.user_date.error_code}});
            setTimeout(() => {
              _this.show2 = false;
            }, 300);
            setTimeout(() => {
              _this.show = false;
            }, 800);
            setTimeout(() => {
              _this.$router.push({
                path: "/index_new",
                // query: {
                // 	login_seciphone: this.seciphone
                // }
              });
            }, 1000);
          } else if (res.data.error_code == "65303") {
            _this.$message({
              message: "密码错误或者帐号与加密狗不匹配！",
              type: "warning",
            });
          } else {
            _this.$message({
              message: res.data.error_message,
              type: "error",
            });
          }
        });

    },
    /* end */

    /* 获取手机验证码 */
    get_message_code(formName) {
      let _this = this;
      // getCode:function(){
      //     this.code_isdisable = true;
      //     this.auth_time = 30;
      //     var auth_timetimer = setInterval(() => {
      //         this.yanzhengname = "重发" + this.auth_time + "秒";
      //         this.auth_time--;
      //         if(this.auth_time < 0) {
      //             console.log('111')
      //             this.yanzhengname = "获取验证码";
      //             this.code_isdisable = false;
      //             clearInterval(auth_timetimer);
      //             }
      //     }, 1000);
      // };
      /*  */
      let postData = this.qs.stringify({
        version: API.VERSION_NUM,
        phone: _this.resetPawForm.pwd_userno,
      });

      _this.$refs[formName].validate((valid) => {
        if (valid) {
          this.code_isdisable = true;
          this.auth_time = 30;
          var auth_timetimer = setInterval(() => {
            this.yanzhengname = "重发" + this.auth_time + "秒";
            this.auth_time--;
            if (this.auth_time < 0) {
              // console.log('111')
              this.yanzhengname = "获取验证码";
              this.code_isdisable = false;
              clearInterval(auth_timetimer);
            }
          }, 1000);

          _this
            .axios({
              method: "POST",
              url: "http://api.ailand.mobi:4024/defaultversion/MuZhiSms/SendVerifySms",
              data: postData,
            })
            .then((res) => {
              // console.log("密码提交---数据成功", res);
            })
            .catch((res) => {
              // console.log("密码提交---失败", res);
            });
        } else {
          console.log("error submit!!!!");
          return false;
        }
      });
    },
    /* end */
    /* 重置密码提交 */
    resetPwd_login() {
      let _this = this;
      let postData = this.qs.stringify({
        version: "v1",
        userno: _this.resetPawForm.pwd_userno,
        checkcode: _this.pwd_code,
        userpwd: _this.resetPawForm.pwd_userpwd,
      });
      _this
        .axios({
          method: "POST",
          url: "http://api.ailand.mobi:9028/api/v1/ALL_Logins/ResetPwd",
          data: postData,
        })
        .then((res) => {
          if (res.data.error_code == 0) {
            _this.$message({
              message: "密码重置成功，请登录",
              type: "success",
            });
            _this.login_forgetpaw = false;
            _this.login_normal = true;
            _this.$refs["resetPawForm"].resetFields();
            _this.pwd_code = "";
          } else if (res.data.error_code == 2000) {
            _this.$message({
              message: "验证码错误",
              type: "error",
            });
          }
          // console.log("重置密码提交---数据成功", res);
        })
        .catch((res) => {
          // console.log("重置密码提交---失败", res);
        });
    },
    /* end */

    getMiddleCode: function () {
      var _this = this;
      var middle_result = _this.$route.query.middle_result;
      var iphone_code = _this.$route.query.iphone_code;
      _this.middle_result = middle_result;
      _this.iphone_code = iphone_code;
      console.log("middle_result:---------", middle_result);
      console.log("iphone_code:---------", iphone_code);
      localStorage.name = iphone_code;
      console.log(localStorage.name);
    },

    enter() {
      this.isactive = "active";
    },

    leave() {
      this.isactive = "";
    },

    showsaoma(){
      this.dl_code2 = true;
      console.log( this.dl_code2)
    },

    hidesaoma(){ 
      this.dl_code2 = false;
    },

    wjshow(){ 
      this.wj = true; 
    },

    hidewj(){
      this.wj = false;
    },
    gmhidewj(){
      this.gm = false;
    },

  },
  /* methods */
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
html,
body {
  background: #fef5f7;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.logo {
  position: absolute;
  width: 100%;
  height: 100px;
  padding-left: 80px;
  padding-top: 40px;
  left: 0;
  top: 0;
  z-index: 1;
}
.circle {
  position: absolute;
  left: 0;
  top: 0;
  padding-left: 50px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  z-index: 2;
}
.circle1 {
  position: absolute;
  transform-origin: center;
  animation: Qz 30s infinite linear;
}
.circle2 {
  position: absolute;
  transform-origin: center;
  animation: Qz 18s infinite linear;
}
.circle3 {
  position: absolute;
  transform-origin: center;
  animation: Qz 24s infinite linear;
}
.circle4 {
  position: absolute;
  transform-origin: center;
  animation: Qz 13s infinite linear;
}
.dl {
  position: absolute;
  width: 1200px;
  height: 800px;
  background: white;
  border-radius: 20px;
  z-index: 5;
  margin-top: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  top: 60px;
  right: 80px;
}
.picture {
  position: relative;
  width: 710px;
  height: 800px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  float: left;
  margin-left: 500px;
  z-index: 9999;
  background-image: url(../assets/picture.png);
  background-position-x: -440px;
  background-position-y: -70px;
}
.login_content {
  position: absolute;
  /* width: 400px;
    height: 530px;
    background:red;
    left: 50px;
    top: 100px;  */
}
.biaoti {
  /* text-align: left; */
  /* background: red; */
  margin-top: 100px;
  padding-left: 50px;
}
.dl_01 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
}
.code {
  text-align: right;
  /* background: red;
    padding-top: 40px;
    margin-left: 40px;     */
}
.box{
  margin-top: 55px;
}

.box2 input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/mima.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
/* 调整忘记密码样式 */
.forget {
  font-size: 16px;
  color: #f198a7;
  text-align: left;
  margin-top: 5px; /* 减小与上方输入框的距离 */
  margin-bottom: 15px; /* 增加与下方登录按钮的距离 */
  cursor: pointer;
  transition: all 0.3s ease;
}

.forget:hover {
  color: #e74c3c;
  text-decoration: underline;
}

/* 调整登录按钮的上边距 */
.login_button {
  width: 394px;
  height: 46px;
  border-radius: 8px;
  background-color: #f198a7;
  margin-top: 20px; /* 减少上边距，因为忘记密码已经移上来了 */
  color: #fff;
  border: none;
  font-size: 16px;
  outline: none;
}
.login_button:hover{
  box-shadow: 0 0 5px #f198a7 !important;
  background-color: #f198a7 !important;
  color: #fff !important;
}
.three_sides {
  font-size: 8px;
  /* text-align:center; */
  padding-top: 620px;
  padding-left: 70px;
}
.three_sides ul li {
  list-style: none;
  float: left;
  padding-left: 30px;
}
.three_sides ul li a {
  color: rgb(196, 196, 196);
  text-decoration: none;
}
.three_sides ul li a:hover {
  color: #f198a7;
}
.login_content2 {
  position: absolute;
  width: 400px;
  height: 530px;
  background: white;
  left: 600px;
  top: 140px;
  z-index: 9999;
}
.scan_code {
  text-align: center;
  /* margin-top: 60px; */
}
.tips {
  font-size: 12px;
}
.atips {
  font-size: 12px;
  text-align: center;
  margin-top: 30px;
}
.dl_02 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
  z-index: 5;
}
.code_02 {
  text-align: right;
}
.dl_03 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  left: 50px;
  top: 190px;
  z-index: 6;
}
.code_03 {
  text-align: right;
}
.wj_mk {
  position: absolute;
  width: 400px;
  height: 530px;
  background: white;
  left: 600px;
  top: 140px;
  z-index: 9999;
}
.wj_code {
  text-align: right;
  padding-top: 40px;
}
.wj_text input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 20px 0;
  background: url(../assets/zhanghao.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
  margin-top: 60px;
}
.wj_text2 input {
  width: 394px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/mima.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
.wj_text3 input {
  width: 308px;
  height: 40px;
  border-radius: 8px;
  margin: 10px 0;
  background: url(../assets/test.png) no-repeat;
  background-color: white;
  background-position: 14px;
  padding-left: 50px;
  border: 1px solid #e4e4e4;
  outline: none;
}
.wj_button {
  width: 394px;
  height: 46px;
  border-radius: 8px;
  background-color: #f198a7;
  margin-top: 40px;
}
.wj-but {
  background-color: #f198a7;
  color: white;
  outline: none;
  font-size: 16px;
  padding-top: 10px;
}
.hq_code {
  border: 1px solid #f198a7;
  border-radius: 8px;
  height: 40px;
  background-color: white;
  color: #f198a7;
  outline: none;
}
.versnumber {
  width: 100%;
  height: 40px;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  margin: 0 auto;
  /* background: #f198a7; */
  padding-top: 10px;
  z-index: 10;
}
.versnumber span {
  margin-left: 640px;
  color: #666666;
}
.password-tips {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
@keyframes Qz {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login_new.vue